import { ReasonForLeave } from '../../types/domain/handoverItem';

export const isReasonForLeave = (value: string): value is ReasonForLeave => {
  return Object.values(ReasonForLeave).includes(value as ReasonForLeave);
};
